import { FDInvestmentJourneyResponseType } from '../../../types/fd-type'
import { FDDetailsStep } from './FDDetailsStep'
import { InputStep } from './InputStep'
import { InvestmentSummaryStep } from './InvestmentSummaryStep'
import { ProgressStep } from './ProgressStep'
import { BestPlanSteps } from '../../../types/fd-type'

export const AllSteps = ({
  currentStepId,
  data,
  handleDisableButton,
  currentInvestment,
  maturityAmount,
  handleInputRelatedAmounts
}: {
  currentStepId: `${BestPlanSteps}`
  data: FDInvestmentJourneyResponseType | undefined
  handleDisableButton: (x: boolean) => void
  currentInvestment: number
  maturityAmount: number
  handleInputRelatedAmounts: ({
    currInvestment,
    matureAmount
  }: {
    currInvestment: number
    matureAmount: number
  }) => void
}) => {
  if (currentStepId === BestPlanSteps.FD_DETAILS_STEP) return <FDDetailsStep data={data} />
  else if (currentStepId === BestPlanSteps.INPUT_STEP)
    return (
      <InputStep
        data={data}
        currentInvestment={currentInvestment}
        handleDisableButton={handleDisableButton}
        handleInputRelatedAmounts={handleInputRelatedAmounts}
      />
    )
  else if (currentStepId === BestPlanSteps.INVESTMENT_SUMMARY_STEP)
    return <InvestmentSummaryStep data={data} currentInvestment={currentInvestment} maturityAmount={maturityAmount} />
  else if (currentStepId === BestPlanSteps.PROGRESS_STEP)
    return <ProgressStep data={data} currentInvestment={currentInvestment} />
  return null
}
